
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/van/volkswagen-transporter",
      function () {
        return require("private-next-pages/tyres/van/volkswagen-transporter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/van/volkswagen-transporter"])
      });
    }
  